import { apiServer, apiServer_v2 } from "common/config";
import { UserBadgesData } from "../types";
import { fetchWithToken } from "./fetchWithToken";

export type FlagUserInput = {
  accessToken: string;
  userId: string;
  image: string;
  notes: string;
};
export async function flagUser({
  accessToken,
  userId,
  image,
  notes,
}: FlagUserInput) {
  const formData = new FormData();
  formData.append("user_id", userId);
  formData.append("notes", notes);

  const file = {
    uri: image,
    type: "image/jpeg",
    name: "image",
  };
  formData.append(`image`, file as any, "image");

  const response = await fetchWithToken(apiServer + "/user/report-issue", {
    method: "POST",
    body: formData,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  });
  return await response?.json();
}

export async function blockUser({
  accessToken,
  userId,
  notes,
}: {
  accessToken: string;
  userId: string;
  notes: string;
}) {
  const formData = new FormData();
  formData.append("user_id", userId);
  formData.append("notes", notes);

  const response = await fetchWithToken(apiServer + "/user/block-user", {
    method: "POST",
    body: formData,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await response?.json();
}

export async function fetchBadges(accessToken: string): Promise<{
  status: string;
  message: string;
  data: UserBadgesData;
}> {
  const response = await fetchWithToken(apiServer + "/user/sync-badges", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await response?.json();
}

export async function fetchPublicUserBadges(userId: string): Promise<{
  status: string;
  message: string;
  data: UserBadgesData;
}> {
  const response = await fetch(apiServer + `/user/public-badges/${userId}`);
  return await response.json();
}

export async function postBasicInfo({
  name,
  gender,
  yearOfBirth,
  accessToken,
}: {
  name: string;
  gender: string;
  yearOfBirth: string;
  accessToken: string;
}) {
  const formData = new FormData();
  formData.append("name", name);
  formData.append("gender", gender);
  formData.append("year_of_birth", yearOfBirth);

  const response = await fetchWithToken(
    apiServer + "/user/profile-user-basic",
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: formData,
    }
  );
  return await response?.json();
}

export async function postPrivacySettings({
  key,
  value,
  accessToken,
}: {
  key: string;
  value: string;
  accessToken: string;
}) {
  const formData = new FormData();
  formData.append("pref_key", key);
  formData.append("pref_value", value);

  console.log(formData);

  const response = await fetchWithToken(
    apiServer + "/user/update-user-account-preference",
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      body: formData,
    }
  );
  return await response?.json();
}

export async function updatProfilePhoto(photo: string, accessToken: string) {
  const formData = new FormData();
  const fileName = `profile_photo.jpg`;
  const file = {
    uri: photo,
    type: "image/jpeg",
    name: fileName,
  };
  formData.append(`photo`, file as any, fileName);

  const response = await fetchWithToken(apiServer + "/user/profile-photo", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: formData,
  });
  return await response?.json();
}

export async function updateProfilePhotoDesktop(
  file: File,
  accessToken: string
) {
  const formData = new FormData();
  formData.append("photo", file, file.name); // Use the file directly

  const response = await fetchWithToken(apiServer + "/user/profile-photo", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: formData,
  });
  return await response?.json();
}

export async function verifyUserEmail(accessToken: string, email: string) {
  const formData = new FormData();
  formData.append("email", email);
  formData.append("token", accessToken);
  // console.log("formData", formData);

  const response = await fetch(apiServer_v2 + "/user/verify-user-email", {
    method: "POST",
    body: formData,
  });
  if (response.status === 403) {
    throw new Error("Try again after few minutes");
  }
  const data = await response.json();
  if (data.status === "error") {
    throw new Error(data.message);
  }
  return data;
}
